import "core-js/modules/es6.string.small.js";
import GlobalIntro from '~/components/molecules/Editorial/Global/GlobalIntro.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
var MediaAndOverlay = function MediaAndOverlay() {
  return import('~/components/molecules/Global/MediaAndOverlayArtDirection.vue');
};
var SPACING = {
  none: 'mt-O',
  small: 'mt-3',
  medium: 'mt-4',
  large: 'mt-double',
  negative: 'mt-negative-double'
};
export default {
  components: {
    GlobalIntro: GlobalIntro,
    // ElementMedia,
    MediaAndOverlay: MediaAndOverlay
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      mobile: false
    };
  },
  computed: {
    ratio: function ratio() {
      var _ref17;
      if (this.mobile) {
        return '4:3';
      }
      return ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.ratioimg : _ref17 : _ref17) || '';
    },
    currentPayload: function currentPayload() {
      var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16;
      var small = formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.image) != null ? (_ref16 = _ref16.small) != null ? _ref16.url : _ref16 : _ref16 : _ref16 : _ref16, [['w_375', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || '';
      var medium = formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? (_ref15 = _ref15.image) != null ? _ref15.url : _ref15 : _ref15 : _ref15, [['w_375', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      var large = formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.image) != null ? (_ref14 = _ref14.large) != null ? _ref14.url : _ref14 : _ref14 : _ref14 : _ref14, [['w_1440', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.image) != null ? _ref13.url : _ref13 : _ref13 : _ref13, [['w_1440', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      return {
        src: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.small) != null ? _ref12.url : _ref12 : _ref12 : _ref12 : _ref12) || '',
        srcsets: {
          small: {
            dimension: '375w',
            srcset: "".concat(small, " 375w")
          },
          medium: {
            dimension: '750w',
            srcset: "".concat(medium, " 750w")
          },
          large: {
            dimension: '1440w',
            srcset: "".concat(large, " 1440w")
          },
          xlarge: {
            dimension: '2880w',
            srcset: "".concat(xlarge, " 2880w")
          }
        },
        image: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.image : _ref11 : _ref11) || null,
        alt: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.alt : _ref10 : _ref10) || '',
        ratioImg: this.ratio,
        backgroundColor: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.background_color : _ref9 : _ref9) || '',
        color: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.color : _ref8 : _ref8) || '#3c3c3b',
        titleLevel: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.title) != null ? (_ref7 = _ref7[0]) != null ? _ref7.type : _ref7 : _ref7 : _ref7 : _ref7) || 'heading1',
        subtitleLevel: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.subtitle) != null ? (_ref6 = _ref6[0]) != null ? _ref6.type : _ref6 : _ref6 : _ref6 : _ref6) || 'heading2',
        videoMp4: formatPrismicImage((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.videoMp4 : _ref5 : _ref5, [], '', 'video') || '',
        videoWebm: formatPrismicImage((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.videoWebm : _ref4 : _ref4, [], '', 'video') || '',
        style: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.style : _ref3 : _ref3) || 'primary',
        gradient: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.gradient : _ref2 : _ref2) === 'Yes'
      };
    },
    builderTopSpacing: function builderTopSpacing() {
      var _ref;
      return SPACING[(_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.spacing : _ref : _ref];
    },
    introStyle: function introStyle() {
      return [{
        'position-relative': !this.hasMedia && this.currentPayload.style === 'primary'
      }, {
        'position-absolute': this.hasMedia && this.currentPayload.style === 'primary'
      }, {
        'mx-auto': this.currentPayload.style === 'secondary'
      }, {
        'h-100': this.currentPayload.style === 'primary'
      }, {
        'justify-content-center': this.currentPayload.style === 'primary'
      }];
    },
    hasMedia: function hasMedia() {
      return Boolean(this.currentPayload.src && this.currentPayload.src.length > 0 || this.currentPayload.videoMp4 && this.currentPayload.videoMp4.length > 0 || this.currentPayload.videoWebm && this.currentPayload.videoWebm.length > 0);
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  }
};